const RouteNames = {
  HOME: '/',

  // Auth
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'forgot-password',
  PASSWORD_RESET: 'password-reset',

  // Footer
  OFFER: 'public-offer',
  POLICY: 'privacy-policy',

  // Account
  VPS: 'vps',

  MONITORING: 'online-monitoring',
  ACCOUNTS: 'accounts',
  GUIDE: 'guide',

  MONITORING_ACCOUNT: ':monitoringId',

  PARTNERS: 'partner-program',

  OPERATIONS: 'balance-operations',

  SUPPORT: 'support',
  TICKET: ':ticketId',

  PROFILE: 'profile',

  FAQ: 'faq',


  ANY: '*',
}

export default RouteNames